import { render, staticRenderFns } from "./Zhuanyerenzheng.vue?vue&type=template&id=336f3fa8&scoped=true"
import script from "./Zhuanyerenzheng.vue?vue&type=script&lang=js"
export * from "./Zhuanyerenzheng.vue?vue&type=script&lang=js"
import style0 from "./Zhuanyerenzheng.vue?vue&type=style&index=0&id=336f3fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f3fa8",
  null
  
)

export default component.exports